import React, { useState } from "react";
import styled from "styled-components";
import DashboardSidebar from "./DashboardSidebar";
import DashboardHeader from "./DashboardHeader";

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f8fafc;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
`;

const SidebarContainer = styled.div`
  width: ${(props) => (props.$collapsed ? "80px" : "280px")};
  transition: width 0.3s ease;
  flex-shrink: 0;
  background: white;
  border-right: 1px solid #e2e8f0;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  z-index: 10;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: ${(props) => (props.$mobileMenuOpen ? "0" : "-280px")};
    height: 100vh;
    width: 280px;
    z-index: 50;
    transition: left 0.3s ease;
  }
`;

const MainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const HeaderContainer = styled.div`
  height: 80px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 5;
`;

const ContentContainer = styled.main`
  flex: 1;
  padding: 24px;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 40;
  display: ${(props) => (props.$show ? "block" : "none")};

  @media (min-width: 769px) {
    display: none;
  }
`;

const DashboardLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <LayoutContainer>
      <SidebarContainer
        $collapsed={sidebarCollapsed}
        $mobileMenuOpen={mobileMenuOpen}
      >
        <DashboardSidebar
          collapsed={sidebarCollapsed}
          onToggle={toggleSidebar}
          onCloseMobile={closeMobileMenu}
        />
      </SidebarContainer>

      <MainContainer>
        <HeaderContainer>
          <DashboardHeader
            onToggleMobileMenu={toggleMobileMenu}
            sidebarCollapsed={sidebarCollapsed}
          />
        </HeaderContainer>

        <ContentContainer>{children}</ContentContainer>
      </MainContainer>

      <MobileOverlay $show={mobileMenuOpen} onClick={closeMobileMenu} />
    </LayoutContainer>
  );
};

export default DashboardLayout;
